import { combineReducers } from "redux";
import profileReducer from "./profileSlice";
import authSlice from "./authSlice";
import themeSlice from "./themeSlice";
import languageSlice from "./languageSlice";
import organizationSlice from "./organizationSlice";
import paymentAccountConnectSlice from "./paymentAccountConnectSlice";
import organizerThemeSlice from "./organizerThemeSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  authProvider: authSlice,
  themeProvider: themeSlice,
  langProvider: languageSlice,
  organization: organizationSlice,
  paymentDetails: paymentAccountConnectSlice,
  organizerThemeData: organizerThemeSlice,
});

export default rootReducer;
